module.exports = __webpack_public_path__ + "img/circle-info-blue.6aafef88.svg";